export const toFloat = (value) => {
  if (!value) {
    return null;
  }
  if (value.match('^[0-9]*$')) {
    return parseInt(value, 10);
  }
  if (value.match('[0-9]+[.][0-9]+$')) {
    return parseFloat(value);
  }
  return value;
};

export const toFloatDecimals = (value) => {
  if (!value) {
    return null;
  }
  if (value.match('^[0-9]*$')) {
    return parseInt(value, 10);
  }
  
  
  if (value.match('^\\d+(?:\\.\\d{1,3})?$')) {
    return parseFloat(value);
  }
  return value;
};

export const toInteger = (value) => {
  if (!value) {
    return null;
  }
  if (value.match('^[0-9]*$')) {
    return parseInt(value, 10);
  }
  return value;
};

export const toUpperCase = (value) => {
  return value.toUpperCase();
};

export const toLowerCase = (value) => {
  return value.toLowerCase();
};
